import { Store, Globe2 } from 'lucide-react'

// Tag visual que diferencia PDV-Loja × PDV-Online por `caixa_canal` (feature
// 09/07 — isolamento por canal). IMPORTANTE: usa caixa_canal (o split do caixa),
// NÃO canal_origem (origem OMS: digitado/celular/marketplace) — a venda do
// PDV-Online tem canal_origem='balcao' mas caixa_canal='online', então só o
// caixa_canal distingue os dois. NULL legado ≡ balcao (Loja).
//
// Mostrada principalmente na visão "Ambos" (quando os dois canais aparecem juntos
// na mesma lista); quando o usuário está trancado num canal, a tag é redundante.
export default function CanalTag({ canal, className = '' }: { canal?: string | null; className?: string }) {
  const online = canal === 'online'
  const Icon = online ? Globe2 : Store
  const cor = online
    ? 'bg-violet-100 text-violet-700 border-violet-200'
    : 'bg-amber-100 text-amber-700 border-amber-200'
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-medium uppercase tracking-wide px-1.5 py-0.5 rounded border ${cor} ${className}`}
      title={online ? 'PDV-Online' : 'PDV-Loja'}
    >
      <Icon size={11} />
      {online ? 'Online' : 'Loja'}
    </span>
  )
}
